import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import { ReturnsMapStore } from './model/redux-model';
import { StoreReducer } from './model/redux-reducers';
import { rootSaga } from './sagas/root';

export const sagaMiddleware = createSagaMiddleware();
export const mapReturnsStore = configureStore<ReturnsMapStore>({
	reducer: StoreReducer,
	middleware: [sagaMiddleware]
});

// sagaMiddleware.run(rootSaga);